import { Button } from '@repo/studio-design-system-ui-button'
import { ROUTES } from '@repo/studio-utils/routes'
import { StudioLayoutLink } from '@repo/studio-config/studio-config-router'

const MCP_LABEL = 'MCP'

function McpButton({ children }: { children: React.ReactNode }) {
  return (
    <Button
      asChild
      size="sm"
      iconOnly
      variant="secondary"
      aria-label={MCP_LABEL}
      className="typography-11"
    >
      {children}
    </Button>
  )
}

export function McpLink({ href }: { href?: string }) {
  if (href) {
    return (
      <McpButton>
        <a href={href} target="_blank" rel="noreferrer">
          {MCP_LABEL}
        </a>
      </McpButton>
    )
  }

  return (
    <McpButton>
      <StudioLayoutLink to={ROUTES.MCP.ROOT}>{MCP_LABEL}</StudioLayoutLink>
    </McpButton>
  )
}
